import * as React from "react";
import List from "@mui/material/List";
import { useAppProvider } from "../AppContext";
import Cat721ListItem from "./Cat721ListItem";
import { CollectionItem, NFTItem } from "../api";
// import { ListItem } from "@mui/material";
// import Cat721NonUpgradeableItem from "./Cat721NonUpgradeableItem";

interface Cat721ListProps {
  items: CollectionItem[];
  swapNft: (collectionItem: CollectionItem, item: NFTItem) => void;
}

export default function Cat721List(props: Cat721ListProps) {
  const { connected } = useAppProvider();
  const items = props.items;

  // const [_collectionItems, setCollectionItems] = React.useState<
  //   CollectionItem[]
  // >([]);

  // React.useEffect(() => {
  //   if (connected() && connectedAccount) {
  //     getCollectionItems(network, connectedAccount.payment.address, true).then(
  //       (items) => {
  //         setCollectionItems(items);
  //       }
  //     );
  //   }
  // }, [connected, connectedAccount, network]);

  const allItem = items.map((item) => {
    return (
      <Cat721ListItem
        key={item.collectionId}
        item={item}
        swap={props.swapNft}
      />
    );
  });

    // if (_collectionItems.length > 0) {
    // allItem.push(
    //   <ListItem key="cat721NonUpgradeableItem" sx={{ padding: 0 }}>
    //     <Cat721NonUpgradeableItem collections={_collectionItems} />
    //   </ListItem>
    // );
    // }

  return (
    <List sx={{ width: "100%", maxWidth: 560, bgcolor: "background.paper" }}>
      {connected() ? allItem : <></>}
    </List>
  );
}
